import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let CostomerManage = class CostomerManage extends Vue {
    constructor() {
        super(...arguments);
        this.snackbar = new CBcSnackbar();
        this.searchForm = {
            keyword: '',
            customerNature: '',
            customerRegion: '',
            sortBy: '',
            sortType: '',
        };
        this.queryRegion = {
            menu: {
                visible: false,
            },
            isEditing: false,
            active: [],
            province: {
                list: [],
                value: undefined,
                loading: false,
            },
            city: {
                list: [],
                value: undefined,
                loading: false,
            },
            area: {
                list: [],
                value: undefined,
                loading: false,
            },
        };
        this.orderTableOption = {
            loading: false,
            headers: [
                {
                    text: '客户名称',
                    align: 'left',
                    sortable: false,
                    value: 'customerName',
                    width: '80',
                },
                // {
                //     text: "客户简称",
                //     align: "center",
                //     sortable: false,
                //     value: "customerShortName",
                //     width: "80",
                // },
                {
                    text: '客户编号',
                    align: 'center',
                    sortable: false,
                    value: 'customerShortName',
                    width: '150',
                },
                {
                    text: '税号',
                    align: 'center',
                    sortable: false,
                    value: 'taxNumber',
                    width: '150',
                },
                {
                    text: '负责人',
                    align: 'center',
                    sortable: false,
                    value: 'principal',
                    width: '80',
                },
                {
                    text: '集团码',
                    align: 'center',
                    sortable: false,
                    value: 'groupCode',
                    width: '150',
                },
                {
                    text: '客户性质',
                    align: 'center',
                    sortable: false,
                    value: 'customerNature',
                    width: '80',
                },
                {
                    text: '客户区域',
                    align: 'center',
                    sortable: false,
                    value: 'customerRegion',
                    width: '80',
                },
                // {
                //     text: "地址",
                //     align: "center",
                //     sortable: false,
                //     value: "address",
                //     width: "150",
                // },
                {
                    text: '电话',
                    align: 'center',
                    sortable: false,
                    value: 'phone',
                    width: '150',
                },
                {
                    text: '开户行',
                    align: 'center',
                    sortable: false,
                    value: 'bank',
                    width: '150',
                },
                {
                    text: '收付款账号',
                    align: 'center',
                    sortable: false,
                    value: 'paymentAccount',
                    width: '150',
                },
                {
                    text: '负责业务员',
                    align: 'center',
                    sortable: false,
                    value: 'respSalesman',
                    width: '92',
                },
                // {
                //     text: "备注",
                //     align: "center",
                //     sortable: false,
                //     value: "remark",
                //     width: "150",
                // },
                {
                    text: '操作',
                    align: 'left',
                    sortable: false,
                    value: 'action',
                    width: '180',
                },
            ],
            desserts: [],
            pagination: {
                pageCount: 1,
                pageNow: 1,
                pageArr: [5, 10, 20, 50, '所有'],
                everyPageCount: 10,
                sumDetail: 0,
            },
        };
        this.dialogOrder = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        this.listHospital = []; // 医院信息
        this.operDateArray = ['deliveryDate', 'docDate', 'rdpConfirmDate', 'pdConfirmDate', 'salesAuditDate', 'gmApprovalDate'];
        this.userInfoDic = {
            list: [],
            value: undefined,
            loading: true,
        };
    }
    get dateRangeText() {
        let str = '';
        if (this.searchForm.docDates.length > 0) {
            str = this.searchForm.docDates.join(' ~ ');
        }
        return str;
    }
    get deliveryDateRangeText() {
        let str = '';
        if (this.searchForm.deliveryDates.length > 0) {
            str = this.searchForm.deliveryDates.join(' ~ ');
        }
        return str;
    }
    async initUserList() {
        const that = this;
        if ((that.userInfoDic.list || []).length > 0) {
            // 已查询过就不在添加
            return;
        }
        that.userInfoDic.loading = true;
        const res = await that.axios.get('/api/users/');
        that.userInfoDic.list = [];
        if (res.data && res.data.result) {
            res.data.result.filter((o) => {
                if (o.usersInfo)
                    that.userInfoDic.list.push(o.usersInfo);
            });
        }
        that.userInfoDic.loading = false;
    }
    // 医院列表
    async getHospitalList() {
        const that = this;
        // 只需要触发一次
        if ((that.listHospital || []).length > 0) {
            return;
        }
        try {
            const ret = await that.axios.get('/api/hospital', { params: { simple: true } }).then((res) => {
                that.listHospital = (res && res.data && res.data.result) || [];
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    searchChange() {
        const that = this;
        clearTimeout(that.searchForm.timer);
        that.searchForm.timer = setTimeout(() => {
            that.getDataList();
        }, 300); // 1秒执行一次获取函数 防抖
    }
    regionFilter(item, queryText, itemText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['pinYin'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['name'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['code'].toUpperCase()));
    }
    async getDataList() {
        const that = this;
        that.orderTableOption.loading = true;
        try {
            const res = await that.axios.get('/api/erp/customer/info', {
                params: {
                    withProducts: true,
                    page: that.orderTableOption.pagination.pageNow,
                    limit: typeof that.orderTableOption.pagination.everyPageCount === 'number'
                        ? that.orderTableOption.pagination.everyPageCount
                        : that.orderTableOption.pagination.sumDetail,
                    keyword: that.searchForm.keyword,
                    hospitalId: that.searchForm.hospitalId,
                    customerNature: !/全部|所有/.test(that.searchForm.customerNature) ? that.searchForm.customerNature : '',
                    customerRegion: !/全部|所有/.test(that.searchForm.customerRegion) ? that.searchForm.customerRegion : '',
                    sortBy: that.searchForm.sortBy,
                    sortType: that.searchForm.sortType,
                },
            });
            that.orderTableOption.desserts = res.data.result || [];
            that.orderTableOption.pagination.sumDetail = res.data.sum || 0;
            // 分页信息处理
            that.orderTableOption.pagination.sumDetail = res.data.sum;
            const pageCount = Math.ceil(res.data.sum / that.orderTableOption.pagination.everyPageCount) || 1;
            that.orderTableOption.pagination.pageCount = pageCount;
            if (that.orderTableOption.pagination.pageNow > pageCount) {
                that.orderTableOption.pagination.pageNow = pageCount;
                that.getDataList();
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.orderTableOption.loading = false;
        }
    }
    changeProvince(ev, type) {
        if (type === 'province') {
            const find = this.queryRegion.province.list.find(v => v.name === ev) || {};
            this.queryRegion.city.list = find.children || [];
            this.queryRegion.area.list = [];
        }
        else if (type === 'city') {
            const find = this.queryRegion.city.list.find(v => v.name === ev) || {};
            this.queryRegion.area.list = find.children || [];
        }
    }
    /**
     * 显示订单表单
     */
    async showOrderFormClick(operType, row) {
        // 添加
        async function addFunc() {
            that.dialogOrder.title = '新增客户信息';
        }
        // 修改
        async function editFunc() {
            that.dialogOrder.title = '修改客户信息';
        }
        // 删除
        async function deleteFunc() {
            that.dialogOrder.title = '删除客户信息';
        }
        async function detail() {
            await editFunc();
            that.dialogOrder.title = '查看客户详情';
        }
        const that = this;
        that.dialogOrder.operType = operType;
        that.dialogOrder.formData = Object.assign({}, row || {});
        that.dialogOrder.products = []; // 清空产品信息
        await that.initUserList();
        if (operType === 'add') {
            await addFunc();
        }
        else if (operType === 'edit') {
            await editFunc();
        }
        else if (operType === 'detail') {
            await detail();
        }
        else {
            await deleteFunc();
        }
        that.dialogOrder.visible = true;
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    async setProduct(productInfo, row) {
        const that = this;
        row.productTypeInfoId = productInfo.id; // 产品id
        row.productInfo = productInfo; // 产品集合
        row.productLine = productInfo.productLine; // 产品线
        row.productType = productInfo.category; // 产品类别
        row.productTypeName = productInfo.category == 0 ? '独立设备' : '包装产品';
        row.deviceCode = ''; // 设备编号 实际
        row.productName = productInfo.productName; // 产品名称
        row.productShortName = productInfo.shortName; // 产品简称
        row.serial = productInfo.serial;
        row.model = productInfo.model;
        row.specifications = productInfo.specifications;
        row.stockInOutQuantity = 1; // 出/库数量默认为1，但是独立设备不运行修改
        row.quantityUnit = productInfo.unit;
        row.inboundType = '生产'; // 入库类型
    }
    /**
     * 获取表单禁用状态
     */
    get getFormDisabled() {
        const that = this;
        return that.dialogOrder.operType === 'begin' || that.dialogOrder.operType === 'detail' || that.dialogOrder.operType === 'end';
    }
    /**
     * 保存订单表单
     */
    async saveOrderForm() {
        const that = this;
        const form = {
            ...that.dialogOrder.formData,
            products: that.dialogOrder.products || [],
        };
        let month = '';
        let url = '/api/erp/customer/info';
        let msg = '';
        // 添加
        if (that.dialogOrder.operType == 'add') {
            month = 'post';
            msg = '添加';
        }
        else if (that.dialogOrder.operType == 'edit') {
            month = 'put';
            url += '/' + form.id;
            msg = '修改';
        }
        else if (that.dialogOrder.operType == 'del') {
            month = 'delete';
            url += '/' + form.id;
            msg = '删除';
        }
        await that.sendOrderSalesResponse({
            month: month,
            url: url,
            form: form,
            msg: msg,
        });
    }
    /**
     * 发送客户信息
     */
    async sendOrderSalesResponse(op) {
        const that = this;
        await that.axios[op.month](op.url, op.form)
            .then((res) => {
            that.dialogOrder.loading = false;
            // 提示成功刷新页面
            that.dialogOrder.visible = false;
            that.snackbar.success(`${op.msg}创建客户信息成功`);
            that.getDataList();
        })
            .catch((e) => {
            that.dialogOrder.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`${op.msg}客户信息错误${resMeg}`);
            console.log(`${op.msg}客户信息错误`, e);
        });
    }
    /**
     * 跳转参数处理
     */
    async skipParams() {
        const that = this;
        const params = this.$route.params || {};
        // 存在订单状态，那么就只需处理查询
        if (params.orderStatus) {
            that.searchForm.orderStatus = params.orderStatus.split(',').map(Number);
            return;
        }
        if (params.operType == 'apply') {
            // 处理弹框显示新增生产订单
            await that.showOrderFormClick('withoutAdd', params.param);
        }
    }
    /**
     * 查询地址
     */
    getRegionList(province, city, area) {
        const that = this;
        try {
            let url = '/api/region';
            if (province !== undefined && city !== undefined && area !== undefined)
                url = `/api/region/provinces/${province}/cities/${city}/areas/${area}`;
            else if (province !== undefined && city !== undefined)
                url = `/api/region/provinces/${province}/cities/${city}`;
            else if (province !== undefined)
                url = `/api/region/provinces/${province}`;
            return that.axios.get(url).then((res) => res.data);
        }
        catch (e) {
            console.log('get region error:', e);
        }
    }
    /**
     * 排序函数
     */
    tableSort(options) {
        const that = this;
        that.searchForm.sortBy = options.prop;
        that.searchForm.sortType = options.type;
        that.searchChange();
    }
    async mounted() {
        this.skipParams();
        await this.getDataList();
        this.getHospitalList();
        this.initUserList();
        const res = await this.getRegionList();
        this.queryRegion.province.list = res;
    }
};
__decorate([
    Getter
], CostomerManage.prototype, "userInfo", void 0);
CostomerManage = __decorate([
    Component({
        name: 'CostomerManage',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
        },
    })
], CostomerManage);
export default CostomerManage;
